export const FITNESS_CONSTS = {
    GET_FITNESS: "GET_FITNESS",
    UPDATE_FITNESS: "UPDATE_FITNESS",
    CREATE_FITNESS_SERVICE: "CREATE_FITNESS_SERVICE",
    GET_FITNESS_SERVICE_BY_ID: "GET_FITNESS_SERVICE_BY_ID",
    UPDATE_FITNESS_SERVICE_BY_ID: "UPDATE_FITNESS_SERVICE_BY_ID",
    DELETE_FITNESS_SERVICE_BY_ID: "DELETE_FITNESS_SERVICE_BY_ID",
};
